class Utils {

	constructor() {
		this.initWhatsapp();
	}

	initWhatsapp() {
		jQuery('.js-whatsapp-open').on('click', (event) => {
			event.preventDefault();
			jQuery('.whatsapp-box').toggle();
		});
	}
}

export default new Utils;